// City and District APIs

/**
 * @function ApiClient#GetCityList
 * @this {ApiClient}
 * @param {any} options = {}
 */
export async function GetCityList(options = {}) {
  return await this._get("/city_list", options);
}
/**
 * @function ApiClient#GetDistrictList
 * @this {ApiClient}
 * @param {any} city
 * @param {any} options = {}
 */
export async function GetDistrictList(city, options = {}) {
  return await this._get(`/district_list?city=${city}`, options);
}
